import { InjectionToken } from '@angular/core';

export interface ItemSizePredictor<T> {
  /**
   * Returns predicted size in px of the item
   * @param item
   * @param index
   */
  getPredictedSize: (item: T, index: number) => number;
}

export const VIRTUAL_SCROLL_ITEM_SIZE_PREDICTOR = new InjectionToken<ItemSizePredictor<any>>(
  'VIRTUAL_SCROLL_ITEM_SIZE_PREDICTOR',
);
